import { css } from '@emotion/react'
import styled from '@emotion/styled'
import React, { ReactNode, useState } from 'react'
import tw from 'tailwind.macro'

type TooltipProps = {
  message: string
  position?: string
  color?: string
  children: ReactNode
}

const TooltipWrapper = styled.span`
  ${tw`relative inline-block max-w-full leading-0`}
`
const TooltipTrigger = styled.span`
  ${tw`inline-block max-w-full leading-0`}
`
const TooltipMessage = styled.div`
  ${tw`p-1 text-center text-white leading-none rounded`}
  background: ${(props) => props.color};
  font-size: 0.75rem !important;
  padding-bottom: 0.35rem;
`
const TooltipBubble = styled.div`
  ${tw`absolute pointer-events-none`}
  z-index: 2;
  min-width: 4rem;
  max-width: 12rem;
  &::after {
    content: '';
    position: absolute;
  }
`
const positions = (key, color) => {
  const positions = {
    top: css`
      bottom: 100%;
      left: 50%;
      padding-bottom: 8px;
      transform: translateX(-50%);

      &::after {
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-top: 8px solid ${color};
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }
    `,
    bottom: css`
      top: 100%;
      left: 50%;
      padding-top: 8px;
      transform: translateX(-50%);

      &::after {
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-bottom: 8px solid ${color};
        top: 0;
        left: 50%;
        transform: translateX(-50%);
      }
    `,
    left: css`
      top: 50%;
      right: 100%;
      padding-right: 8px;
      transform: translateY(-50%);

      &::after {
        border-left: 8px solid ${color};
        border-top: 8px solid transparent;
        border-bottom: 8px solid transparent;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
      }
    `,
    right: css`
      top: 50%;
      left: 100%;
      padding-left: 8px;
      transform: translateY(-50%);

      &::after {
        border-right: 8px solid ${color};
        border-top: 8px solid transparent;
        border-bottom: 8px solid transparent;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
      }
    `,
  }
  return positions[key]
}

const Tooltip = ({
  message,
  position = `top`,
  color = `rgba(0,0,0,.85)`,
  children,
  ...rest
}: TooltipProps & Record<string, any>) => {
  const [showTooltip, setShowTooltip] = useState(false)

  return (
    <TooltipWrapper onMouseLeave={() => setShowTooltip(false)} {...rest}>
      {showTooltip && (
        <TooltipBubble css={positions(position, color)}>
          <TooltipMessage color={color}>{message}</TooltipMessage>
        </TooltipBubble>
      )}
      <TooltipTrigger onMouseOver={() => setShowTooltip(true)}>{children}</TooltipTrigger>
    </TooltipWrapper>
  )
}

export default Tooltip
